<template>
  <header>
    <div class="main-content">
      <router-link :to="{name:'Home', query:{skin: 'sjm', lang, secret}}" class="logo" v-if="skin==='sjm'" replace>
        <h1 class="logo-title">
          {{ $t('pvmTitle:Hotel Online Reservations') }}
          <img alt="logo" src="@/assets/images/logo_sjm.svg" class="logo-img">
          <img alt="logo" src="@/assets/images/logo_sjm_mob.png" class="logo-fixed-img">
        </h1>
      </router-link>
      <router-link :to="{name:'Home', query:{skin: 'gl', lang, secret}}" class="logo" v-else-if="skin==='gl'" replace>
        <h1 class="logo-title">
          {{ $t('glTitle:Hotel Online Reservations') }}
          <img alt="logo" src="@/assets/images/hotel/gl-logo.png" class="logo-img">
          <img alt="logo" src="@/assets/images/hotel/gl-logo-mob.png" class="logo-fixed-img gl-log">
        </h1>
      </router-link>
      <router-link :to="{name:'Home', query:{skin: 'glp', lang, secret}}" class="logo" v-else replace>
        <h1 class="logo-title">
          {{ $t('title:Hotel Online Reservations') }}
          <img alt="logo" src="@/assets/images/logo.png" class="logo-img">
          <img alt="logo" src="@/assets/images/logo_fixed.png" class="logo-fixed-img">
        </h1>
      </router-link>
      <header-switch/>
    </div>
  </header>
</template>

<script>
// @ is an alias to /src
import HeaderSwitch from '@/components/layout/HeaderSwitch.vue'

export default {
  components: {
    HeaderSwitch
  },
  computed: {
    skin() {
      return this.$store.state.gaData.skinCode
    },
    lang() {
      return this.$i18n.locale
    },
    secret() {
      return this.$route.query.secret || localStorage.secret
    }
  }
}
</script>
